<template>
  <div class="question-body">
    <div class="question-box box-pc"
      :class="{ 'question-industryTypeOther': form.industryType == 'Other (其他)' || form.purposeOfInquiry == 'Other (其他)', 'question-Other': form.industryType == 'Other (其他)' && form.purposeOfInquiry == 'Other (其他)' }">
      <div class="dialog-back">
        <el-button size="mini" type="primary" @click="goBack">
          <div>返回</div>
          <div>Return</div>
        </el-button>
      </div>
      <img class="title" src="../../assets/images/title.png">
      <el-form ref="pcForm" :model="form" :rules="rules">
        <div class="flex">
          <el-form-item style="width: 48%;" label="Name (姓名):" prop="name">
            <el-input v-model="form.name" placeholder="Please Enter Name" />
          </el-form-item>
          <el-form-item style="width: 48%;" label="Email (邮箱):" prop="email">
            <el-input v-model="form.email" placeholder="Please Enter Email" />
          </el-form-item>
        </div>
        <el-form-item label="Phone (电话):">
          <el-input placeholder="Please Enter Phone" v-model="form.phone" class="input-with-select">
            <el-select v-model="globalCode" slot="prepend" filterable>
              <el-option v-for="(item, index) in globalCodeOptions" :key="index"
                :label="'+' + item.dialCode + ' - ' + item.name" :value="item.dialCode"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="Company Name (公司名称):">
          <el-input v-model="form.companyName" placeholder="Please Enter Company Name" />
        </el-form-item>
        <div class="flex">
          <el-form-item style="width: 48%;" label="Industry Type (行业类型):" prop="industryType">
            <el-select style="width: 100%;" v-model="form.industryType" placeholder="Please Select Industry Type"
              filterable>
              <el-option v-for="dict in industryTypeOptions" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
          <el-form-item style="width: 48%;" label="Purpose of Inquiry (咨询目的):" prop="purposeOfInquiry">
            <el-select style="width: 100%;" v-model="form.purposeOfInquiry"
              placeholder="Please Select Purpose of Inquiry" filterable>
              <el-option v-for="dict in purposeOfInquiryOptions" :key="dict.id" :label="dict.name" :value="dict.id" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item v-if="form.industryType == 'Other (其他)'" label="Industry Type Other(行业类型其他补充信息):"
          prop="industryTypeOther">
          <el-input type="textarea" :rows="2" resize="none" v-model="form.industryTypeOther"
            placeholder="Please Enter Industry Type Other" />
        </el-form-item>
        <el-form-item v-if="form.purposeOfInquiry == 'Other (其他)'" label="Purpose of Inquiry Other(咨询目的其他补充信息):"
          prop="purposeOfInquiryOther">
          <el-input type="textarea" :rows="2" resize="none" v-model="form.purposeOfInquiryOther"
            placeholder="Please Enter Purpose of Inquiry Other" />
        </el-form-item>
        <el-form-item label="Additional Comments (其他补充信息):">
          <el-input type="textarea" :rows="2" resize="none" v-model="form.additionalComments"
            placeholder="Please Enter Additional Comments" />
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="primary" @click="getCode('pcForm')">
          <div>提交</div>
          <div>Submit</div>
        </el-button>
      </div>
    </div>
    <div class="question-mobiel box-mobiel">
      <div class="dialog-back">
        <el-button size="mini" type="primary" @click="goBack">
          <div>返回</div>
          <div>Return</div>
        </el-button>
      </div>
      <img class="title" src="../../assets/images/title.png">
      <el-form ref="mobileForm" :model="form" :rules="rules">
        <el-form-item label="Name (姓名):" prop="name">
          <el-input v-model="form.name" placeholder="Please Enter Name" />
        </el-form-item>
        <el-form-item label="Email (邮箱):" prop="email">
          <el-input v-model="form.email" placeholder="Please Enter Email" />
        </el-form-item>
        <el-form-item label="Phone (电话):">
          <el-input placeholder="Please Enter Phone" v-model="form.phone" class="input-with-select">
            <el-select v-model="globalCode" slot="prepend" filterable>
              <el-option v-for="(item, index) in globalCodeOptions" :key="index"
                :label="'+' + item.dialCode + ' - ' + item.name" :value="item.dialCode"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="Company Name (公司名称):">
          <el-input v-model="form.companyName" placeholder="Please Enter Company Name" />
        </el-form-item>
        <el-form-item label="Industry Type (行业类型):" prop="industryType">
          <el-select style="width: 100%;" v-model="form.industryType" placeholder="Please Select Industry Type">
            <el-option v-for="dict in industryTypeOptions" :key="dict.id" :label="dict.name" :value="dict.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.industryType == 'Other (其他)'" label="Industry Type Other(行业类型其他补充信息):"
          prop="industryTypeOther">
          <el-input type="textarea" :rows="2" resize="none" v-model="form.industryTypeOther"
            placeholder="Please Enter Industry Type Other" />
        </el-form-item>
        <el-form-item label="Purpose of Inquiry (咨询目的):" prop="purposeOfInquiry">
          <el-select style="width: 100%;" v-model="form.purposeOfInquiry"
            placeholder="Please Select Purpose of Inquiry">
            <el-option v-for="dict in purposeOfInquiryOptions" :key="dict.id" :label="dict.name" :value="dict.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.purposeOfInquiry == 'Other (其他)'" label="Purpose of Inquiry Other(咨询目的其他补充信息):"
          prop="purposeOfInquiryOther">
          <el-input type="textarea" :rows="2" resize="none" v-model="form.purposeOfInquiryOther"
            placeholder="Please Enter Purpose of Inquiry Other" />
        </el-form-item>
        <el-form-item label="Additional Comments (其他补充信息):">
          <el-input type="textarea" :rows="5" resize="none" v-model="form.additionalComments"
            placeholder="Please Enter Additional Comments" />
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="primary" @click="getCode('mobileForm')">
          <div>提交</div>
          <div>Submit</div>
        </el-button>
      </div>
    </div>

    <!-- 图形验证码 -->
    <Verify ref="verify" :captcha-type="'blockPuzzle'" :img-size="{ width: '400px', height: '200px' }"
      @success="submitForm" />

  </div>
</template>
<script>
import Verify from '@/components/Verifition/Verify';
import { createQuestionnaire } from "@/api/index";
export default {
  components: {
    Verify
  },
  data() {
    return {
      // 表单参数
      form: {},
      globalCode: "",//区号
      globalCodeOptions: require('country-telephone-data').allCountries,
      // 表单校验
      rules: {
        name: [{ required: true, message: "Please Enter Name", trigger: "blur" }],
        email: [{ required: true, message: "Please Enter Email", trigger: "blur" }],
        industryType: [{ required: true, message: "Please Select Industry Type", trigger: "change" }],
        purposeOfInquiry: [{ required: true, message: "Please Select Purpose of Inquiry", trigger: "change" }],
        industryTypeOther: [{ required: true, message: "Please Enter Industry Type Other", trigger: "blur" }],
        purposeOfInquiryOther: [{ required: true, message: "Please Enter Purpose of Inquiry Other", trigger: "blur" }],
      },
      industryTypeOptions: [
        {
          id: "Technology (科技)",
          name: "Technology (科技)",
        }, {
          id: "AI (人工智能)",
          name: "AI (人工智能)",
        }, {
          id: "VR/AR (虚拟现实/增强现实)",
          name: "VR/AR (虚拟现实/增强现实)",
        }, {
          id: "Equipment/Hardware (设备/硬件)",
          name: "Equipment/Hardware (设备/硬件)",
        }, {
          id: "Entertainment (娱乐)",
          name: "Entertainment (娱乐)",
        }, {
          id: "Sports & Fitness (体育&健身)",
          name: "Sports & Fitness (体育&健身)",
        }, {
          id: "Other (其他)",
          name: "Other (其他)",
        },
      ],
      purposeOfInquiryOptions: [
        {
          id: "Business Opportunity (商务合作)",
          name: "Business Opportunity (商务合作)",
        }, {
          id: "General Information (一般咨询)",
          name: "General Information (一般咨询)",
        }, {
          id: "Partnership Inquiry (合作洽谈)",
          name: "Partnership Inquiry (合作洽谈)",
        }, {
          id: "Product/Service Inquiry (产品或服务咨询)",
          name: "Product/Service Inquiry (产品或服务咨询)",
        }, {
          id: "Other (其他)",
          name: "Other (其他)",
        }
      ]
    };
  },
  mounted() {
    this.reset()
  },
  methods: {
    // 表单重置
    reset() {
      this.form = {
        name: undefined,
        email: undefined,
        phone: undefined,
        companyName: "",
        industryType: undefined,
        industryTypeOther: undefined,
        purposeOfInquiry: undefined,
        purposeOfInquiryOther: undefined,
        additionalComments: "",
        captchaVerification: undefined,//验证码
      };
      this.globalCode = "86"
    },
    // 提交表单
    submitForm(captchaParams) {
      if (this.form.industryType == 'Other (其他)') {
        this.form.industryType = this.form.industryTypeOther
      }

      if (this.form.purposeOfInquiry == 'Other (其他)') {
        this.form.purposeOfInquiry = this.form.purposeOfInquiryOther
      }

      if (this.form.phone) {
        this.form.phone = '+' + this.globalCode + this.form.phone
      } else {
        this.form.phone = undefined
      }

      this.form.captchaVerification = captchaParams.captchaVerification

      createQuestionnaire(this.form)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: 'You did it! Thanks for sharing your info! The Partyday team will be in touch soon.',
              type: 'success'
            });

            setTimeout(() => {
              window.location.href = 'https://partydaysport.com/';
            }, 2000)

          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });

          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 验证码
    getCode(formRef) {
      this.$refs[formRef].validate(valid => {
        if (valid) {
          this.$refs.verify.show()
        }
      });
    },
    // 返回
    goBack() {

      // 缓存语言
      var storageLang = localStorage.getItem('language');
      if (storageLang) {
        if (storageLang == 'cn') {
          window.location.href = "/cn/contact.html";
        } else if (storageLang == 'en') {
          window.location.href = "/en/contact.html";
        } else if (storageLang == 'tc') {
          window.location.href = "/tc/contact.html";
        }
        return
      }

      // 浏览器语言
      var lang = navigator.language || navigator.userLanguage;
      if (lang.startsWith("zh")) {
        window.location.href = "/cn/contact.html";
      } else {
        window.location.href = "/en/contact.html";
      }
    }
  },
};
</script>
<style lang="less">
.input-with-select .el-select .el-input {
  width: 150px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item__label {
  font-size: 12px;
  line-height: 20px;
}

.el-input__inner,
.el-textarea__inner {
  font-size: 12px;
}

.el-form-item {
  margin-bottom: 15px;
}

.el-button--primary {
  background-color: #000;
  border-color: #000;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background: rgba(0, 0, 0, .8);
  border-color: rgba(0, 0, 0, .8);
}


.box-pc {
  display: block;
}

.box-mobiel {
  display: none;
}

.dialog-back {
  position: absolute;
  right: 30px;
  top: 20px;
}

.title {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.question-body {
  width: 100%;
  height: 100vh;
  background-image: url(../../assets/images/bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;


  .question-industryTypeOther {
    height: 590px !important;
  }

  .question-Other {
    height: 670px !important;
  }

  .question-box {
    width: 550px;
    height: 580px;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #fff;
    border-radius: 5px;
    padding: 0 30px 30px;
    box-sizing: border-box;


    .flex {
      display: flex;
      justify-content: space-between;
    }
  }

  .dialog-footer {
    width: 100%;

    .el-button {
      width: 100%;
    }
  }
}

/* 响应式设计：在屏幕宽度小于 480px 时调整字体和布局 */
@media (max-width: 780px) {

  .el-select-dropdown__item {
    white-space: normal !important;
    word-break: break-all !important;
    // line-height: 1.5 !important;
    /* 增加行高 */
  }

  .el-select-dropdown {
    left: 2.5% !important;
    max-width: 95% !important;
  }

  .el-form-item__label {
    font-size: 10px !important;
  }

  .box-pc {
    display: none;
  }

  .box-mobiel {
    display: block;
  }

  .el-input__inner,
  .el-textarea__inner {
    border: 1px solid #000;
  }

  .question-mobiel {
    background-color: #fff;
    min-height: 100%;
    position: relative;
    padding: 15px 20px 70px;
    box-sizing: border-box;

    .dialog-back {
      position: absolute;
      right: 20px;
    }
  }

  // .verifybox {
  // max-width: 350px !important;

  // .verify-img-out,.verify-sub-block {
  //   height: 150px !important;
  // }

  // .verify-img-panel {
  //   width: 100% !important;
  //   height: 150px !important;
  // }

  // .verify-bar-area {
  //   width: 100% !important;
  // }

  // .verify-sub-block{
  //   top: -150px !important;
  //   width: 50px !important;
  // }
  // }

  .dialog-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0 20px 20px;
    box-sizing: border-box;
    background: #fff;
  }
}
</style>
